import * as React from 'react';
import Synth from './Synth';
import './index.css';
import { RemoveScroll } from 'react-remove-scroll';
import { BACKGROUND_COLOR, TEXTURE_A, COLOR_B, COLOR_A } from './CONSTANTS';

import Test from './TestReactGL';

const App = () => {
	const [isOn, setOn] = React.useState(false);

	return (
		<React.Fragment>
			<RemoveScroll />
			<div
				style={{
					height: window.innerHeight,
					maxWidth: '60vh',
					margin: 'auto',
					marginTop: '0px',
					marginBottom: '0px',
					background: BACKGROUND_COLOR,
					mixBlendMode: 'normal',
					overflow: 'hidden',
				}}
			>
				{isOn ? (
					<Synth></Synth>
				) : (
					<React.Fragment>
						<div
							style={{
								height: '90%',
								textAlign: 'center',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-evenly',
							}}
							onClick={() => setOn(true)}
						>
							<div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
								<h2 style={{ textAlign: 'left', color: COLOR_B }}>
									noise<br></br>sculpting<br></br>synthesizer
								</h2>
							</div>
							<div>
								<button
									style={{
										width: '70%',
										marginLeft: 'auto',
										marginRight: 'auto',
										color: COLOR_B,
										border: '2px solid' + COLOR_B,
									}}
								>
									ENTER
								</button>
							</div>
							<p style={{ fontSize: '1.2rem', color: COLOR_B }}>
								contact: njona@kth.se <br />
							</p>
						</div>
					</React.Fragment>
				)}
			</div>
		</React.Fragment>
	);
};

export default App;
